import type { ButtonProps } from '@ag1/ui';
import {
  SHOPIFY_AG1_POUCH_DOUBLE_SUB_VARIANT_ID_V53,
  SHOPIFY_AG1_POUCH_OTP_VARIANT_ID_V53,
  SHOPIFY_AG1_POUCH_SINGLE_SUB_VARIANT_ID_V53,
  SHOPIFY_TRAVEL_PACK_DOUBLE_SUB_VARIANT_ID_V53,
  SHOPIFY_TRAVEL_PACK_OTP_VARIANT_ID_V53,
  SHOPIFY_TRAVEL_PACK_SINGLE_SUB_VARIANT_ID_V53
} from '@portal/config/base';

export const FIRST_STEP_NAME = 'offer-builder-bundle-step-0-option';
export const SECOND_STEP_NAME = 'offer-builder-bundle-step-1-option';

export const ButtonStaticProps: ButtonProps = {
  type: 'submit',
  rounded: true,
  fluid: true
};

export const enum Step {
  One = 1,
  Two = 2,
  Three = 3
}

export enum CheckoutBaBType {
  ONE_TIME = 'oneTime',
  SUBSCRIPTION = 'subscription'
}

export const VARIANT_ID_MAP = {
  pouch: {
    single: SHOPIFY_AG1_POUCH_SINGLE_SUB_VARIANT_ID_V53,
    double: SHOPIFY_AG1_POUCH_DOUBLE_SUB_VARIANT_ID_V53,
    OTP: SHOPIFY_AG1_POUCH_OTP_VARIANT_ID_V53,
    family: SHOPIFY_AG1_POUCH_DOUBLE_SUB_VARIANT_ID_V53
  },
  'travel-pack': {
    single: SHOPIFY_TRAVEL_PACK_SINGLE_SUB_VARIANT_ID_V53,
    double: SHOPIFY_TRAVEL_PACK_DOUBLE_SUB_VARIANT_ID_V53,
    OTP: SHOPIFY_TRAVEL_PACK_OTP_VARIANT_ID_V53,
    family: SHOPIFY_TRAVEL_PACK_DOUBLE_SUB_VARIANT_ID_V53
  }
} as const;

export const desktopMediaMap = {
  original: 'image-2aac65022c5537ddec9ea018493bd1fe6c154e44-2109x2109-jpg',
  tropical: 'image-d18304c329182a1b02137a8c1a52b6406e1df05a-2109x2109-jpg',
  citrus: 'image-e21dfd92c8c0aab4f57938582129b73a19097dd2-2109x2109-jpg',
  berry: 'image-c1917999230c903cc4badd790caca88e29169734-2109x2109-jpg'
};

export const mobileMediaMap = {
  original: 'image-80417cdff2d39dc7b891143661ed4b8195cb22d9-1017x510-png',
  tropical: 'image-2aa801c17f48808ef823e923d2f410d7932d0ee1-1017x510-png',
  citrus: 'image-2f8cee1052faa4951571ed0b27cc5f6ceaa5a3c9-1017x510-png',
  berry: 'image-6e6b6a07f822bdd0ae5816e7f311789fea5fecda-1017x510-png'
};

// use this map to override the image for a specific offer in a specific environment
// data hierachy: environment => offerId => stepNumber => productCategory
export const OFFER_BAB_IMAGE_OVERRIDE_MAP = new Map([
  [
    'production',
    new Map([
      [
        174,
        new Map([
          [
            1,
            new Map([
              [
                'pouch',
                {
                  customClassName: 'beigeBackground',
                  desktop: 'image-85eb6ffa934a2bb1d8fc1fac7300a79b1d3559bd-2880x3234-png',
                  mobile: 'image-85eb6ffa934a2bb1d8fc1fac7300a79b1d3559bd-2880x3234-png'
                }
              ],
              [
                'travel-pack',
                {
                  customClassName: 'beigeBackground',
                  desktop: 'image-ff049592f227f5fa86dd7799dd914f087491ed82-2880x3234-png',
                  mobile: 'image-ff049592f227f5fa86dd7799dd914f087491ed82-2880x3234-png'
                }
              ]
            ])
          ]
        ])
      ]
    ])
  ]
]);
